import { EMPTY_COUNTS, SEARCH_ERRORS } from "@search/api/constants";
import { LabelResource, type SearchResponse } from "@search/api/types";
import { useSearchStore } from "@search/store/useSearchStore";
import useSWRImmutable from "swr/immutable";

import { getJSONWithCredentials } from "@/utils/swr";

const DEFAULT_VALUES = {
  counts: EMPTY_COUNTS,
  limitPerPage: 0,
  nameResources: {} as LabelResource,
  pageCount: 0,
  results: [],
  suggestions: [],
  totalResults: 0,
};
const PATHNAME = "search";

const searchUrl = (query: string) => {
  const url = new URL(`api/${PATHNAME}`, import.meta.env.VITE_API_HOST);

  url.search = query;

  return url;
};

const search = getJSONWithCredentials<SearchResponse>(
  SEARCH_ERRORS.GENERIC_ERROR,
);

export const useSearchQuery = () => {
  const { getQuery } = useSearchStore((state) => state);
  const query = getQuery();
  const url = searchUrl(query);
  const {
    data,
    error,
    isLoading: isSearchLoading,
  } = useSWRImmutable(url.href, search);

  return {
    ...DEFAULT_VALUES,
    ...data?.data,
    isSearchLoading,
    searchError: (error as Error) || !!data?.errors.at(0),
    searchQuery: url.search,
  };
};
